const TmpL004 = (page, section) => {
  // pull  data from the page
  const media = [];
  const materials = [];
  const eMentors = [];
  const modifiedPage = {
    ...page,
  };

  page.content.core.forEach((card, index) => {
    // modify the media object from the page data
    const cardMedia = {
      id: card.id,
      page: page.id,
      author: "Team ACV/AAC",
      author_desc_en: "Team ACV/AAC",
      author_desc_tl: "N/A",
      cc_license: "N/A",
      description: "Flash Card Pronuciation",
      downloaded_date: new Date().toISOString(),
      published_date: new Date().toISOString(),
      media_url: "https://base-media-repo.web.app/" + page.label.slice(0, 2).toUpperCase() + "/audio/" + page.label.toLowerCase().replaceAll("-", "_") + "_" + index + ".mp3",
      source_url: "Team ACV/AAC",
      src: page.label.toLowerCase().replaceAll("-", "_") + "_" + index + ".mp3",
      title_en: card.term_en || "MISSING TERM",
      title_tl: card.term_tl || "MISSING TL TERM",
      transcript: card.term_tl || "MISSING TRANSCRIPT",
      type: "audio",
    }
    // add the media object to the media array
    media.push(cardMedia);
    // update the media object in te modified page data
    modifiedPage.content.core[index].pronunciation = page.label.toLowerCase().replaceAll("-", "_") + "_" + index + ".mp3";
  });
  // Inventory object
  const material = {
    content: modifiedPage.content.core,
    page: page.id,
    section: section,
    type: "flashcards",
  }

  // update the core object to match the material object
  modifiedPage.content.core = {
    id: page.id,
    material: page.id,
  };

  // update the the ementor content with the page id
  if (page.content.eMentor) {
    page.content.eMentor.forEach((mentor) => {
      const eMentor = {
        ...mentor,
        page: page.id,
      };
      eMentors.push(eMentor);
    });
  } 
  
  
  // Extract metadata separately
  const metadata = {
    media: media || [],
    images: [],
    materials: [material] || [],
    eMentor: eMentors,
    focusPoints: [],
  };

  return { modifiedPage, metadata };
};

export default TmpL004;